import React from 'react';

export interface SegmentedControlOption<T extends string | number> {
    value: T;
    label: string;
    disabled?: boolean;
}

export interface SegmentedControlProps<T extends string | number> {
    options: SegmentedControlOption<T>[];
    value: T;
    onChange: (value: T) => void;
    ariaLabel: string;
    size?: 'default' | 'sm';
    className?: string;
}

const SegmentedControl = <T extends string | number>({ options, value, onChange, ariaLabel, size = 'default', className = '' }: SegmentedControlProps<T>): React.JSX.Element => {
    const classes = ['btn-group btn-group-tabs', size === 'sm' ? 'btn-group-tabs-sm' : '', className].filter(Boolean).join(' ');

    return (
        <div className={classes} role="group" aria-label={ariaLabel}>
            {options.map((option) => {
                const isActive = option.value === value;
                return (
                    <button
                        key={option.value}
                        type="button"
                        className={`btn${isActive ? ' active' : ''}`}
                        aria-pressed={isActive}
                        disabled={option.disabled}
                        onClick={() => onChange(option.value)}
                    >
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
};

export default SegmentedControl;
